import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingBag, X } from 'lucide-react';
const notifications = [{
  flagCode: 'gb',
  countryName: 'United Kingdom',
  location: 'London, UK',
  name: 'Sarah Mitchell',
  initials: 'SM',
  time: '5 minutes ago'
}, {
  flagCode: 'ca',
  countryName: 'Canada',
  location: 'Toronto, Canada',
  name: 'Claire Vance',
  initials: 'CV',
  time: '12 minutes ago'
}, {
  flagCode: 'au',
  countryName: 'Australia',
  location: 'Sydney, Australia',
  name: 'James Reid',
  initials: 'JR',
  time: '18 minutes ago'
}, {
  flagCode: 'us',
  countryName: 'United States',
  location: 'New York, USA',
  name: 'Vera Thompson',
  initials: 'VT',
  time: '27 minutes ago'
}, {
  flagCode: 'ie',
  countryName: 'Ireland',
  location: 'Dublin, Ireland',
  name: 'Sinead Ryan',
  initials: 'SR',
  time: '41 minutes ago'
}];
export function PurchaseNotifications() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    if (isDismissed) return;
    const timer = window.setTimeout(() => setIsVisible(true), 3000);
    return () => window.clearTimeout(timer);
  }, [isDismissed]);
  useEffect(() => {
    if (isDismissed || !isVisible) return;
    const hideTimer = window.setTimeout(() => {
      setIsVisible(false);
      window.setTimeout(() => {
        if (!isDismissed) {
          setCurrentIndex(previous => (previous + 1) % notifications.length);
          setIsVisible(true);
        }
      }, 1500);
    }, 5000);
    return () => window.clearTimeout(hideTimer);
  }, [currentIndex, isDismissed, isVisible]);
  if (isDismissed) return null;
  const current = notifications[currentIndex];
  return <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 pointer-events-none w-full px-4 flex justify-center" data-id="element-208" data-mp="3j94064ht0d14">
      <AnimatePresence mode="wait" data-id="element-209" data-mp="3kruaxcflzyj8">
        {isVisible && <motion.div key={currentIndex} initial={{
        opacity: 0,
        y: 40,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.96
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-paper border border-silver-light rounded-xl p-3.5 shadow-[0_10px_30px_-14px_rgba(21,23,26,0.35)] w-full max-w-[360px] pointer-events-auto relative" data-id="element-210" data-mp="3ppm0w0wp1aks">
            <button type="button" onClick={() => setIsDismissed(true)} className="absolute top-2 right-2 text-graphite-light hover:text-ink transition-colors duration-150 ease-out" aria-label="Close notification" data-id="element-211" data-mp="36t4e7xwpc0ve">
              <X size={14} data-id="element-212" data-mp="2j28pj9njllsd" />
            </button>
            <div className="flex items-center gap-3" data-id="element-213" data-mp="2n3k66pofuwof">
              <div className="relative shrink-0" data-id="element-214" data-mp="2n290gkbfneuo">
                <div className="w-11 h-11 rounded-full bg-ink flex items-center justify-center text-white font-display font-bold text-sm" data-id="element-215" data-mp="24e8f8o1fh0ld">
                  {current.initials}
                </div>
                <img src={`https://flagcdn.com/w40/${current.flagCode}.png`} alt={`${current.countryName} flag`} className="absolute -bottom-1 -right-1 w-5 h-5 rounded-full object-cover border-2 border-white shadow" data-id="element-216" data-mp="2dfy4pobr1pgi" />
              </div>
              <div className="flex-1 min-w-0 pr-4" data-id="element-217" data-mp="2ifayyu4y9yt4">
                <div className="flex items-center gap-1.5 text-[11px] text-graphite-light mb-0.5" data-id="element-218" data-mp="2icezv2hd9433">
                  <img src={`https://flagcdn.com/w20/${current.flagCode}.png`} alt="" className="w-4 h-3 rounded-sm object-cover" data-id="element-219" data-mp="2w7qw5eb672m4" />
                  <span className="truncate" data-id="element-220" data-mp="3150ujjgjeom3">{current.location}</span>
                </div>
                <p className="text-ink text-[13px] leading-snug" data-id="element-221" data-mp="31366hw9yygds">
                  <span className="font-bold" data-id="element-222" data-mp="3l6ly4h3ig98t">{current.name}</span>{' '}
                  <span className="text-graphite" data-id="element-223" data-mp="3p7xctrkuja28">purchased Boxing Coach Ready</span>
                </p>
                <div className="flex items-center gap-1.5 text-[10px] text-accent-dark font-medium mt-1" data-id="element-224" data-mp="3tz5qx0x4fjlq">
                  <span className="w-1.5 h-1.5 rounded-full bg-accent" data-id="element-225" data-mp="2s2xe2tt918c" />
                  <ShoppingBag size={10} aria-hidden="true" data-id="element-226" data-mp="328rgjeobgpet" />
                  <span data-id="element-227" data-mp="32accn8qa4ges">Verified purchase • {current.time}</span>
                </div>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}